import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter/index'
import { Helmet } from 'react-helmet'

function index() {
  return (
      <DefaultLeadsPage leadType="All" />
  )
}

export default index